import ExhibitorsRelatedContainer from "../../../Component/Application/ExhibitorsRelated/ExhibitorsRelatedContainer";

const ExhibitorsRelatedPage = () => {
    return (
        <div className="page-body">
            <ExhibitorsRelatedContainer />
        </div>
    );
};

export default ExhibitorsRelatedPage;